/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/12/2024
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notificationPageOpen: false,
  notificationStatus: null,
  selectedNotification: null,
};

export const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    openNotificationForm: (state, action) => {
      state.notificationPageOpen = action.payload;
    },

    setNotificationStatus: (state, action) => {
        state.notificationStatus = action.payload;
    },

    setSelectedNotification: (state, action) => {
        state.selectedNotification = action.payload;
    },
  },
});

export const {
  openNotificationForm,
  setNotificationStatus,
  setSelectedNotification
} = NotificationSlice.actions;

export default NotificationSlice.reducer;